import { Stack } from '@festina-life/ui/structure'

import { ReconciliationSpecTimelineDiagram } from '../../components/reconciliationSpecTimeline/ReconciliationSpecTimelineDiagram'

/**
 * Sidebar of the reconciliation-spec viewer, holding the version history used to pick
 * the version to view.
 */
export const ReconciliationSpecSidebar = () => (
  <Stack
    gap="spacious"
    padding="spacious"
    className="size-full flex-col overflow-auto"
  >
    <ReconciliationSpecTimelineDiagram />
  </Stack>
)
